/**
 * Mazeed Pay — platform house brand (green).
 *
 * The parent/platform brand per F9 (R2: "the platform brand is Mazeed Pay").
 * Green ramp anchored on #59CC03 — the platform green shared with the mobile
 * app's design tokens (`mazeedpay-app/src/components/ui/colors.js`).
 */
import type { BrandConfig } from '../types';

const mazeed: BrandConfig = {
  key: 'mazeed',
  // MAZEEDPAY_TENANT_ID — services/shared/shared/tenants.py. Keep in lockstep.
  tenantId: '019fbd71-2ec0-77c0-bef3-3473d42a6255',
  // Seeded by platform-service migration 0021 — the dev-only resolve fallback.
  devHost: 'mazeedpaydev.com',
  branding: {
    displayName: 'Mazeed Pay',
    // Square green-squircle icon → rendered beside the "Mazeed Pay" name as a
    // lockup (no standalone wordmark asset).
    logoLightUrl: '/brands/mazeed/logo.svg',
    logoDarkUrl: null,
    logoType: 'mark',
    faviconUrl: '/brands/mazeed/mark.png',
    colorTokens: {
      // Full 50→700 brand ramp — green, tints/shades around the #59CC03 core.
      brand50: '#EDFBE0',
      brand100: '#D6F5BD',
      brand200: '#B4EC8A',
      brand300: '#8FE056',
      brand400: '#71D42B',
      brand500: '#59CC03',
      brand600: '#4BAD02',
      brand700: '#3E9202',
      // Legacy three-key contract, kept aligned with the ramp.
      primary: '#59CC03',
      secondary: '#4BAD02',
      accent: '#71D42B',
    },
    fontFamily:
      "Manrope, ui-sans-serif, -apple-system, 'Segoe UI', Roboto, sans-serif",
    customCss: null,
    supportPhone: null,
    supportEmail: 'support@mazeedpay.com',
    termsUrl: null,
  },
  html: {
    title: 'Mazeed Pay · Admin',
    description:
      'Mazeed Pay Admin — Manage merchant credit, device financing, customers, payments, and operations.',
    themeColor: '#59CC03',
    faviconHref: '/brands/mazeed/mark.png',
    appleTouchIconHref: '/brands/mazeed/mark.png',
  },
};

export default mazeed;
